<template>
	<el-radio-group v-if="data.setting.isRemote && model"
					v-model="model[data.fieldId]"
					:disabled="disabled"
					@change="radioChange">
		<el-radio :label="r.value"
				  v-for="(r, index) in radioOptions"
				  :key="'radioOptions' + index">{{r.label}}</el-radio>
	</el-radio-group>
	<el-radio-group v-else-if="data.setting.isRemote && !model"
					v-model="data.value"
					:disabled="disabled"
					@change="radioChange">
		<el-radio :label="r.value"
				  v-for="(r, index) in radioOptions"
				  :key="'radioOptions' + index">{{r.label}}</el-radio>
	</el-radio-group>
	<el-radio-group v-else-if="!data.setting.isRemote && model"
					v-model="model[data.fieldId]"
					:disabled="disabled"
					@change="radioChange">
		<el-radio :label="r.value"
				  v-for="r in radioOptions"
				  :key="r.value">{{r.label}}</el-radio>
	</el-radio-group>
	<el-radio-group v-else
					v-model="data.value"
					:disabled="disabled"
					@change="radioChange">
		<el-radio :label="r.value"
				  v-for="r in radioOptions"
				  :key="r.value">{{r.label}}</el-radio>
	</el-radio-group>
</template>

<script>
import RemoteMixin from '../../utils/remote-mixin'
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpRadio',
	mixins: [RemoteMixin],
	inject: [ 'customFormOptions' ],
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		},

		radioOptions() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'options')) {
				if (this.customFormOptions[this.data.fieldId].options.length > 0 && this.model[this.data.fieldId] === '') {
					this.model[this.data.fieldId] = this.customFormOptions[this.data.fieldId].options[0].value
				}
				return this.customFormOptions[this.data.fieldId].options
			} else {
				return []
			}
		}
	},
	methods: {
		radioChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>